export const FIRST_LOGIN = {
  CHANGE_DATA: '[first_login] CHANGE_DATA',
  CONFIRM_DATA: '[first_login] CONFIRM_DATA'
};
